import { motion } from 'framer-motion'

interface PageHeroProps {
  label: string
  title: string
  intro?: string
}

export default function PageHero({ label, title, intro }: PageHeroProps) {
  return (
    <header className="bg-accent pt-32 pb-16 md:pt-40 md:pb-20">
      <div className="container max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="text-sm font-semibold text-white/80 uppercase tracking-wider">
            {label}
          </span>
          <h1 className="text-4xl md:text-6xl font-bold font-heading text-white tracking-tight mt-2 mb-6">
            {title}
          </h1>
          {intro && (
            <p className="text-xl text-white/80 leading-relaxed max-w-2xl">
              {intro}
            </p>
          )}
        </motion.div>
      </div>
    </header>
  )
}
